import { ITransactionResponse } from 'types/exchange';
import * as ExchangeActionTypes from '../../actiontypes/exchange';

import makeTransaction from './makeTransaction';

/** ----------------------------------------------------------------------------
 * BUY ITEMS
 -----------------------------------------------------------------------------*/

export const buyItemsRequested = () => ({ type: ExchangeActionTypes.BUY_ITEMS_REQUESTED });

export const buyItemsSuccess = (data: ITransactionResponse) => ({ type: ExchangeActionTypes.BUY_ITEMS_SUCCESS, payload: data });

export const buyItemsFailure = (error: any) => ({
  type: ExchangeActionTypes.BUY_ITEMS_FAILURE,
  error: true,
  status: error.response && error.response.status,
});

const buyItems = makeTransaction('buy', {
  failure: buyItemsFailure,
  requested: buyItemsRequested,
  success: buyItemsSuccess,
});
export default buyItems;